// src/pages/auth/ForgotPassword.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import "./forgotpassword.css"; // Archivo para estilos

const ForgotPassword = () => {
  // Estados locales para el email, mensajes y errores
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Se obtiene la URL del backend desde la variable de entorno VITE_STRAPI_URL.
  // Si no está definida, se usa "http://localhost:1337" como fallback.
  const apiUrl = import.meta.env.VITE_STRAPI_URL || "http://localhost:1337";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      // Llama al endpoint de restablecimiento de contraseña en Strapi
      const res = await fetch(`${apiUrl}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("Si el correo existe, se ha enviado un email para restablecer tu contraseña.");
      } else {
        setError(data.error?.message || "Error al enviar el correo de restablecimiento.");
      }
    } catch (err) {
      console.error(err);
      setError("Error al conectar con el servidor.");
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-card">
        <h2 className="forgot-title">Restablecer Contraseña</h2>
        <p className="forgot-info">
          Ingresa tu correo electrónico y te enviaremos un link para restablecer tu contraseña.
        </p>
        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="form-group">
            <label>
              Correo Electrónico <span className="required">*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu-email@ejemplo.com"
              required
              className="form-control"
            />
          </div>
          <button type="submit" className="btn btn-primary">
            Enviar correo
          </button>
        </form>
        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <p className="back-link">
          <Link to="/login">Volver a Iniciar Sesión</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;